import React, { useCallback, useEffect, useRef, useState } from 'react';
import { get, join } from 'lodash';
import styled from 'styled-components';

import { getColumnText } from 'src/presentation/components/pages/shared/utils/textUtils';
import { Tooltip } from 'src/presentation/components/agent_desktop_components';

const TOOLTIP_ELEMENTS = 8;

export const StringArrayColumn = <T extends Record<string, string>>({
  attr,
  item,
}: {
  attr: string;
  item: T;
}): JSX.Element => {
  const textRef = useRef();

  const list = get(item, attr, []);

  const [text, setText] = useState('');
  const [tooltipText, setTooltipText] = useState('');

  const updateTextHandler = useCallback(() => {
    const current: any = get(textRef, 'current');
    if (current) {
      const text = getColumnText({ items: list, clientWidth: current.clientWidth });
      setText(text);

      if (list.length > 1 && text.includes('and') && text.includes('more')) {
        let toTooltip = join(list.slice(0, TOOLTIP_ELEMENTS), '\r\n');
        toTooltip += list.length > TOOLTIP_ELEMENTS ? `\r\n... and ${list.length - TOOLTIP_ELEMENTS}` : '';
        setTooltipText(toTooltip);
      }
    }
  }, [textRef, list]);

  useEffect(() => {
    window.addEventListener('resize', updateTextHandler);
    return () => window.removeEventListener('resize', updateTextHandler);
  }, [updateTextHandler]);

  useEffect(() => {
    updateTextHandler();
  }, [updateTextHandler]);

  return list.length > 1 ? (
    <StringArrayColumnContainer ref={textRef} data-aid="string-array-column-multi-element">
      <Tooltip delay={250} message={tooltipText} position="top">
        {text}
      </Tooltip>
    </StringArrayColumnContainer>
  ) : (
    <span data-aid="string-array-column-single-element">{list}</span>
  );
};

const StringArrayColumnContainer = styled.div`
  width: 100%;
`;
